import React from "react";

import stories from "../stories";
import poems from "../poems";
import StoryCardWide from "./storycardWide";
import PoemCardWide from "./poemCardWide";

const Home = () => {
  return (
    <div>
      <div>
        <h1 className="text-4xl font-bold text-center my-8">नमस्कार और स्वागत है</h1>
        <p className="text-lg text-center mb-8">
          मेरी कहानियों और कविताओं के संसार में आपका स्वागत है। यहां आप मेरे द्वारा लिखित विभिन्न रचनाओं का आनंद ले सकते हैं।
        </p>
        <br></br>
      
        <button className="bg-blue-500 text-white text-2xl px-4 py-2 m-5 rounded hover:bg-blue-600">
          <a href="/creations">सभी रचनाएँ देखें</a>
        </button>

      </div>

      <h2 className="text-3xl font-bold text-left my-8">नवीनतम रचनाएँ</h2>
    
      <div className="flex flex-col items-center sm:grid sm:grid-cols-3 md:grid-cols-4 gap-2">
        
      {stories.slice(0, 3).map((story, index) => (
        <StoryCardWide key={index} story={story} />
      ))}
      {poems.slice(0, 3).map((poem, index) => (
        <PoemCardWide key={index} poem={poem} />
      ))}
      </div>
    </div>
  );
};

export default Home;
